export interface ListingAttributes {
  [attributeId: string]: string | number;
}

export interface ListingFilters {
  price_min?: number;
  price_max?: number;
  region?: string;
  city?: string;
  user_id?: string;
  category_id?: string;
  slug?: string;
  attributes?: ListingAttributes;
  condition?: ConditionOption | ConditionOption[];
}

export interface ListingQueryPagination {
  start: number;
  end: number;
}

export interface ListingQueryParams extends ListingQueryPagination {
  sortBy?: string;
  order?: string;
  filters?: ListingFilters;
}

export interface User {
  id: string;
  name: string;
  profileImage?: string;
}

export interface Attribute {
  id: string;
  attribute_id: string;
  name: string;
  type: 'integer' | 'string' | 'integer_option' | 'string_option';
  value: string | number | string[];
  optionValue?: string | number | string[];
  // option?: {
  //   id: string;
  //   value: string | number;
  // };
}

export enum ConditionOption {
  NEW = 'new',
  USED = 'used',
  DAMAGED = 'damaged',
}

export interface ListingModel {
  id: string;
  title: string;
  description?: string;
  category_id: string;
  region: string;
  city: string;
  price: number;
  phone_number: string;
  created_at: string;
  has_viber: boolean;
  is_archived: boolean;
  slug: string;
  user: User;
  condition: ConditionOption;
  attributes: Attribute[];
  images: { index: string; url: string; thumbnail_url?: string }[];
}

export interface ListingItemModel
  extends Omit<ListingModel, 'attributes' | 'phone_number' | 'has_viber'> {}

export interface ListingCollectionModel {
  listings: ListingItemModel[];
  total: number;
}
